import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  width: 100%;
  max-width: 800px;
  padding-top: 24px;
  overflow-y: auto;
  height: 100%;
  & > :first-child {
    margin-bottom: 0 !important;
  }
`;

export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
`;

export const ItemWrapper = styled.div<{ $isSelected: boolean }>`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  border-radius: 8px;
  border: 1px solid
    ${({ theme, $isSelected }) => ($isSelected ? theme.colors.green6 : theme.colors.black4)};
  background: ${({ theme, $isSelected }) =>
    $isSelected ? theme.colors.green1 : theme.colors.white};
  cursor: pointer;
  width: 100%;

  &:hover {
    background: ${({ theme }) => theme.colors.green1};
    border: 1px solid ${({ theme }) => theme.colors.green6};
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.colors.green6};
    border-color: ${({ theme }) => theme.colors.green6};
  }
`;

export const SectionInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const PracticeCountWrapper = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const SkeletonWrapper = styled.div`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black4};
  background: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  width: 100%;
`;
